import { SR_API_ACTION_LISTING_GET_LEAD_HEALTH } from 'api/actionTypes';
import typeCheck from 'common/util/typeCheck';

export default async function getLeadHealth(
  { state, apiClient },
  { listingId, forceRefresh = false },
) {
  typeCheck('listingId::PositiveNumber', listingId);

  const statePath = ['listingLeadHealth', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  const leadHealth = await apiClient.postWithState({
    action: SR_API_ACTION_LISTING_GET_LEAD_HEALTH,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(leadHealth) {
      state.set(statePath, leadHealth);
    },
  });

  return leadHealth;
}
